import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.2.8_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(frontend)/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CitiesExploreBlock"] */ "/app/src/blocks/CitiesExplore/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevelopersCarouselBlock"] */ "/app/src/blocks/DevelopersCarouselBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedAgencyBlock"] */ "/app/src/blocks/FeaturedAgencyBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlock"] */ "/app/src/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroBlock"] */ "/app/src/blocks/HeroBlock/Components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomePageListing"] */ "/app/src/blocks/HomePageListing/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropertyCategoriesBlock"] */ "/app/src/blocks/PropertyCategoriesBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecommendedSearchBlock"] */ "/app/src/blocks/RecommendedSearch/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogCard"] */ "/app/src/components/BlogCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/app/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
